import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Form, Modal } from "antd";
import { toastError, toastSuccess } from "../../helpers/toasters";
import {
  acceptOfferByUserByOrderList,
  getMoneyCollecionTypes,
  getProfitAndPercentageByOrderList,
  getUserBalanceInfoByTypeApi,
} from "../../network";
import { ROUTES } from "../../constants/_routes";
import AcceptedOffer from "./AcceptedOffer";
import RejectedOffer from "./RejectedOffer";
// import { doc, increment, updateDoc } from "firebase/firestore";
// import db from "../../firebase";

function NotificationModal({
  isOpen,
  onCancel,
  selectedItem,
  handleRenderParents,
  onBuyingFromStore,
}) {
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingProfit, setLoadingProfit] = useState(false);
  const [profit, setProfit] = useState(0);
  const [profitPercentage, setProfitPercentage] = useState(0);
  const [invalid, setInvalid] = useState(true);
  const [commissionPercentage, setCommissionPercentage] = useState(0);
  const [commission, setCommission] = useState(0);
  const [managementFees, setManagementFees] = useState(0);
  const [priceAfterDeduction, setPriceAfterDeduction] = useState(0);
  const [typeItems, setTypeItems] = useState(null);
  const [collectionTypes, setCollectionTypes] = useState(null);
  const [selectedCollectionTypeId, setSelectedCollectionTypeId] =
    useState(null);
  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isAccepted = selectedItem?.isAccepted;

  const handleInputOnChange = (value, item) => {
    setTypeItems((prevData) => {
      const soldItems = prevData.map((itm) => {
        if (item?.orderId === itm?.orderId) {
          return {
            ...item,
            inputValue: +value,
          };
        } else {
          return itm;
        }
      });
      return soldItems;
    });
  };

  const handleSelectItem = (event, orderId) => {
    setTypeItems((prevData) =>
      prevData.map((item) =>
        item.orderId === orderId
          ? {
              ...item,
              isSelected: event.target.checked,
              inputValue: event.target.checked ? item.remainingQuantity : 0,
            }
          : item,
      ),
    );
  };

  const getProfit = () => {
    setLoadingProfit(true);
    const payload = {
      purchaseRequestId: selectedItem.purchaseRequestId,
    };
    const orders = typeItems
      .filter((item) => item.isSelected)
      .map((item) => {
        return { orderId: item.orderId, sealedQuantity: item.inputValue };
      });
    payload.orders = orders;
    getProfitAndPercentageByOrderList(
      payload,
      (res) => {
        setLoadingProfit(false);
        if (res.success) {
          setProfit(res.data.prophitValue);
          setProfitPercentage(res.data.prophitPercentage);
          setCommissionPercentage(res.data.commissionPercentage);
          setCommission(res.data.greenMatterCommission);
          setPriceAfterDeduction(res.data.sellingPriceAfterCommissionDeduction);
          setManagementFees(res?.data?.managementFees);
        } else {
          toastError(res.message);
        }
      },
      (res) => {
        setLoadingProfit(false);
        toastError(res.message);
      },
    );
  };

  const handleOnCancel = () => {
    setLoading(false);
    setItem({});
    onCancel();
  };

  const handleBuyingFromStore = () => {
    const payload = {
      purchaseRequestId: item.purchaseRequestId,
      isAccepted: item.isAccepted,
      moneyColleectionTypeId: 2,
      storeItemId: "",
      quantity: 0,
      priceAfterCommissionDeduction: priceAfterDeduction,
    };
    const orders = typeItems
      .filter((item) => item.isSelected)
      .map((item) => {
        return { orderId: item.orderId, sealedQuantity: item.inputValue };
      });
    payload.orders = orders;
    onBuyingFromStore();
    navigate(ROUTES.STORE, { state: { purchaseData: payload } });
  };

  const handleOnFinish = (values) => {
    if (loading || loadingProfit) return;
    setLoading(true);

    const payload = {
      purchaseRequestId: item.purchaseRequestId,
      isAccepted: item.isAccepted,
      moneyColleectionTypeId: selectedCollectionTypeId || 1,
    };

    if (item.isAccepted) {
      const orders = typeItems
        .filter((item) => item.isSelected)
        .map((item) => {
          return { orderId: item.orderId, sealedQuantity: item.inputValue };
        });
      payload.orders = orders;
      payload.paymentTypeId = selectedCollectionTypeId;
    }

    acceptOfferByUserByOrderList(
      payload,
      (success) => {
        if (success?.success) {
          toastSuccess(success.message);
          handleOnCancel();
          handleRenderParents();
        } else {
          setLoading(false);
          toastError(success.message);
        }
      },
      (fail) => {
        toastError(fail.message);
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    if (!typeItems) return;

    let valid = false;
    for (let item of typeItems) {
      if (item.isSelected) {
        if (
          item.inputValue &&
          item.inputValue > 0 &&
          item.inputValue <= item.remainingQuantity
        ) {
          valid = true;
        } else {
          valid = false;
          break;
        }
      }
    }

    setInvalid(!valid);

    if (!valid) {
      setProfit(0);
      setCommissionPercentage(0);
      setProfitPercentage(0);
      setCommission(0);
      setManagementFees(0);
      return;
    }

    const timer = setTimeout(() => {
      getProfit();
    }, 500);

    return () => clearTimeout(timer);
  }, [typeItems]);

  useEffect(() => {
    if (selectedItem) {
      setItem(selectedItem);
      getUserBalanceInfoByTypeApi(
        selectedItem.typeId,
        (res) => {
          if (res.success) {
            const updatedItems = res.data.items.map((item) => {
              return {
                ...item,
                isSelected: false,
                inputValue: item.remainingQuantity,
              };
            });
            setTypeItems(updatedItems);
          } else {
            toastError(res.message);
          }
        },
        (res) => {
          toastError(res.message);
        },
      );
    }
  }, [selectedItem]);

  useEffect(() => {
    getMoneyCollecionTypes(
      (res) => {
        if (res.success) {
          setCollectionTypes(res.data);
          if (res.data?.length) {
            setSelectedCollectionTypeId(res.data[0].id);
          }
        } else {
          toastError(res.message);
        }
      },
      (res) => {
        toastError(res.message);
      },
    );
  }, []);

  return (
    <Fragment>
      <Modal
        centered
        width={
          selectedItem?.isAccepted
            ? window.innerWidth >= 992
              ? "80%"
              : "90%"
            : "auto"
        }
        className="notificationModal"
        destroyOnClose={true}
        maskClosable={false}
        open={isOpen}
        onCancel={onCancel}
        closable={true}
        footer={false}
      >
        <Form
          className="payment-details-form"
          onFinish={handleOnFinish}
          layout="vertical"
          dir={dir}
          autoComplete="off"
        >
          {isAccepted ? (
            <AcceptedOffer
              typeItems={typeItems}
              loadingProfit={loadingProfit}
              loading={loading}
              invalid={invalid}
              profit={profit}
              profitPercentage={profitPercentage}
              commission={commission}
              commissionPercentage={commissionPercentage}
              managementFees={managementFees}
              priceAfterDeduction={priceAfterDeduction}
              onSelect={handleSelectItem}
              onInputChange={handleInputOnChange}
              collectionTypes={collectionTypes}
              selectedCollectionTypeId={selectedCollectionTypeId}
              onCollectionTypeChange={setSelectedCollectionTypeId}
              t={t}
            />
          ) : (
            <RejectedOffer loading={loading} t={t} />
          )}
        </Form>
      </Modal>
    </Fragment>
  );
}

export default NotificationModal;
